// Small hand-drawn-feeling line icons. 24×24 grid, round caps, 1.75 stroke.

const PATHS = {
  home: 'M4 11.5 12 5l8 6.5M6.5 10v9h4v-5h3v5h4v-9',
  board: 'M4 5.5h16v11H4zM8 16.5 6.5 20M16 16.5l1.5 3.5M8 9h5M8 12h8M12 3v2.5',
  pencil: 'M15.5 5.5l3 3L9 18l-4 1 1-4zM13.5 7.5l3 3',
  person: 'M12 12a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5ZM5 20c.8-3.6 3.6-5.5 7-5.5s6.2 1.9 7 5.5',
  reply: 'M5 18.5V17a5 5 0 0 1 5-5h9M14.5 7.5 19 12l-4.5 4.5',
  heart: 'M12 19s-7-4.3-7-9.2A3.8 3.8 0 0 1 12 8a3.8 3.8 0 0 1 7 1.8C19 14.7 12 19 12 19Z',
  flag: 'M6 20V4.5M6 5h10.5l-2 3.5 2 3.5H6',
  more: 'M6 12h.01M12 12h.01M18 12h.01',
  check: 'M5 12.5 9.5 17 19 7.5',
  shield: 'M12 3.5 5 6v5.5c0 4.2 2.9 7.3 7 9 4.1-1.7 7-4.8 7-9V6z',
  pin: 'M12 20.5s-6-5.6-6-10.5a6 6 0 0 1 12 0c0 4.9-6 10.5-6 10.5ZM12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
  back: 'M14.5 6 8.5 12l6 6',
  close: 'M6.5 6.5l11 11M17.5 6.5l-11 11',
  mail: 'M4 6.5h16v11H4zM4.5 7l7.5 6 7.5-6',
  logout: 'M14 5.5H6v13h8M10.5 12H20M16.5 8.5 20 12l-3.5 3.5',
  block: 'M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM6.4 6.4l11.2 11.2',
  phone: 'M8.5 3.5h7a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1ZM11 17.5h2',
  map: 'M4 6.5 9 4.5l6 2 5-2v13l-5 2-6-2-5 2zM9 4.5v13M15 6.5v13',
  sun: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4',
  refresh: 'M19 12a7 7 0 1 1-2.05-4.95M19 4.5V8h-3.5',
  camera:
    'M4 8.5A1.5 1.5 0 0 1 5.5 7h2l1.5-2h6l1.5 2h2A1.5 1.5 0 0 1 20 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5zM12 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
} as const;

export type IconName = keyof typeof PATHS;

interface Props {
  name: IconName;
  size?: number;
  className?: string;
  /** Provide for standalone meaningful icons; omit when next to visible text. */
  label?: string;
  filled?: boolean;
}

export function Icon({ name, size = 20, className, label, filled = false }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={name === 'more' ? 3 : 1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
